import React from 'react'

import { AttachmentComponent } from 'common/builder/components/chart/FlowChart/components/Block/components/AttachmentComponent/AttachmentComponent'
import { PreviewComponent } from 'common/builder/components/chart/FlowChart/components/Block/components/PreviewComponent/PreviewComponent'
import { TextContent } from 'common/builder/components/chart/FlowChart/components/Block/components/TextContent/TextContent'
import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import { useFilteredFromSmartlinksButtons } from 'common/builder/components/chart/FlowChart/hooks/useFilteredFromSmartlinksButtons'
import { useTextContentParts } from 'common/builder/components/chart/FlowChart/hooks/useTextContentParts'
import { DEFAULT_NODE_WIDTH } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import {
  FlowChartMediaMessageBlock,
  MediaMessageBodyType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartMediaMessageBlock'

import * as styles from './MediaMessage.style'
import { TextWithIconContent } from './MediaMessageTextWithIconBody'

const CONTAINER_WIDTH = DEFAULT_NODE_WIDTH - sharedStyles.Spacings.NODE_HORIZONTAL_PADDING * 2

export const MediaMessageBlock: BlockComponent<FlowChartMediaMessageBlock> = ({ block }) => {
  const { body, buttons, attachment, preview } = block.data
  const text = body?.type === MediaMessageBodyType.TEXT ? body.text : ''
  const { textContent, smartLinkButtonIdsMap } = useTextContentParts(text)
  const isBodyEmpty = !body || !body?.text
  const isEmptyContainer = isBodyEmpty && buttons.length === 0
  const filteredButtons = useFilteredFromSmartlinksButtons(buttons, smartLinkButtonIdsMap)

  return (
    <InteractiveBlockContainer id={block.id}>
      {attachment && (
        <AttachmentComponent
          attachment={attachment}
          containerProps={{
            style: styles.WithSpacer,
          }}
        />
      )}
      {preview && (
        <PreviewComponent
          url={preview.url}
          size={preview.size}
          targetWidth={CONTAINER_WIDTH}
          style={styles.WithSpacer}
        />
      )}
      <ContentContainer isEmpty={isEmptyContainer}>
        {body?.type === MediaMessageBodyType.TEXT_WITH_ICON && <TextWithIconContent body={body} />}
        {body?.type === MediaMessageBodyType.TEXT && (
          <TextContent content={!body.text ? null : textContent} buttons={buttons} />
        )}
        {filteredButtons.map((button) => (
          <Button key={button.id} button={button} />
        ))}
      </ContentContainer>
    </InteractiveBlockContainer>
  )
}
